import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import "../styles/Partners.css";

function PartnerRequestForm() {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    nom: '',
    organisation: '',
    email: '',
    tel: '',
    message: ''
  });
  const [submitStatus, setSubmitStatus] = useState(null); // null, 'success', 'error'
  const [validationErrors, setValidationErrors] = useState([]); // List of field names with errors

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    // Remove field from errors when user starts typing
    if (validationErrors.includes(name)) {
      setValidationErrors(prev => prev.filter(item => item !== name));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitStatus(null);

    // Manual validation for required fields
    const errors = [];
    if (!formData.nom) errors.push('nom');
    if (!formData.organisation) errors.push('organisation'); // It was marked as required in previous JSX
    if (!formData.email) errors.push('email');
    if (!formData.message) errors.push('message');

    if (errors.length > 0) {
      setValidationErrors(errors);
      setSubmitStatus('error');
      return;
    }

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL || 'http://127.0.0.1:8000/api'}/partner-requests/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({
          nom: '',
          organisation: '',
          email: '',
          tel: '',
          message: ''
        });
        setValidationErrors([]);
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      setSubmitStatus('error');
    }
  };

  return (
    <section className="partner-request-section show">
      {/* Modal Confirmation */}
      {(submitStatus === 'success' || (submitStatus === 'error' && validationErrors.length === 0)) && (
        <div className="tiwizi-modal-overlay" onClick={() => setSubmitStatus(null)}>
          <div className="tiwizi-modal-card" onClick={(e) => e.stopPropagation()}>
            <div className={`tiwizi-modal-icon ${submitStatus === 'success' ? 'success' : 'error'}`}>
              {submitStatus === 'success' ? (
                <svg viewBox="0 0 24 24" width="32" height="32" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12" /></svg>
              ) : (
                <svg viewBox="0 0 24 24" width="32" height="32" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10" /><line x1="12" y1="8" x2="12" y2="12" /><line x1="12" y1="16" x2="12.01" y2="16" /></svg>
              )}
            </div>
            <h2>{submitStatus === 'success' ? t('partners.modalSuccessTitle') : t('partners.modalErrorTitle')}</h2>
            <p>
              {submitStatus === 'success'
                ? t('partners.modalSuccessDesc')
                : t('partners.modalErrorDesc')}
            </p>
            <div className="tiwizi-modal-actions">
              <button className="tiwizi-btn-cancel" onClick={() => setSubmitStatus(null)}>{t('partners.closeBtn')}</button>
            </div>
          </div>
        </div>
      )}

      <div className="form-title-group">
        <h1>{t('partners.formTitle1')} <span className="keyword">{t('partners.formTitleKeyword')}</span></h1>
        <p>{t('partners.formSubtitle')}</p>
      </div>

      <form className="partner-form" onSubmit={handleSubmit}>
        {/* Inline validation error message */}
        {submitStatus === 'error' && validationErrors.length > 0 && (
          <div className="status-message status-error">
            {t('partners.errFields')}
          </div>
        )}

        <div className="form-row-grid">
          <div className="form-group">
            <label htmlFor="nom">{t('partners.labelName')} <span className="required-star">*</span></label>
            <input
              type="text"
              id="nom"
              name="nom"
              className={validationErrors.includes('nom') ? 'input-error' : ''}
              placeholder={t('partners.phName')}
              value={formData.nom}
              onChange={handleChange}
            />
          </div>
          <div className="form-group">
            <label htmlFor="organisation">{t('partners.labelOrg')} <span className="required-star">*</span></label>
            <input
              type="text"
              id="organisation"
              name="organisation"
              className={validationErrors.includes('organisation') ? 'input-error' : ''}
              placeholder={t('partners.phOrg')}
              value={formData.organisation}
              onChange={handleChange}
            />
          </div>
        </div>

        <div className="form-row-grid">
          <div className="form-group">
            <label htmlFor="email">{t('partners.labelEmail')} <span className="required-star">*</span></label>
            <input
              type="email"
              id="email"
              name="email"
              className={validationErrors.includes('email') ? 'input-error' : ''}
              placeholder={t('partners.phEmail')}
              value={formData.email}
              onChange={handleChange}
            />
          </div>
          <div className="form-group">
            <label htmlFor="tel">{t('partners.labelPhone')}</label>
            <input
              type="tel"
              id="tel"
              name="tel"
              placeholder={t('partners.phPhone')}
              value={formData.tel}
              onChange={handleChange}
            />
          </div>
        </div>

        <div className="form-group full-width">
          <label htmlFor="message">{t('partners.labelMsg')} <span className="required-star">*</span></label>
          <textarea
            id="message"
            name="message"
            className={validationErrors.includes('message') ? 'input-error' : ''}
            placeholder={t('partners.phMsg')}
            value={formData.message}
            onChange={handleChange}
          ></textarea>
        </div>

        <div className="submit-btn-container">
          <button type="submit" className="btn-primary">{t('partners.submitBtn')}</button>
        </div>
      </form>
    </section>
  );
}

export default PartnerRequestForm;
